import Vue from 'vue'
Vue.config.productionTip = false

let vm = {
  delimiters: ['{', '}'],
  name: 'title-label',
  props: ['title', 'sub_title', 'oaid', 'router', 'routerType'],
  props: {
    title: String,
    sub_title: String,
    oaid: String,
    router: String,
    router: String,
    routerType: {
      type: String,
      default: "rating"
  }
  },
  data: () => {
    return {
      current: ['mail']
    }
  },
  methods: {
    routerCheck() {
      // 如果使用路由模式，移除a标签href属性，添加路由跳转点击函数，router为跳转页面路径
      let self = this
      if(self.router){
        self.$refs.labelA.removeAttribute("href")
        self.$refs.labelA.onclick = function() {
            self.$router.push({name: self.router, params: {oaid: self.oaid}})
        }
      }
    }
  },
  mounted () {
    this.routerCheck()
  },
}
Vue.component("title-label", vm)
export default vm



// WEBPACK FOOTER //
// ./src/entity/js/title_label.js